import { GetWorkerHistoryListResponse } from '@/services';

import { formatDate, map } from 'utils';

export const formatWorkerHistoryDetail = (
	input: GetWorkerHistoryListResponse['content'][number],
	index: number,
	params: {
		total: number;
		page: number;
		pageSize: number;
	}
) => {
	return {
		...input,
		no: params.total - (params.page - 1) * params.pageSize - index,
		registDt: formatDate(input.registDt),
	};
};

export const formatWorkerHistoryList = (
	input: GetWorkerHistoryListResponse['content'],
	params: {
		total: number;
		page: number;
		pageSize: number;
	}
) => {
	return map(input, (value, index) =>
		formatWorkerHistoryDetail(value, index, params)
	);
};
